
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';

const AIContentSettings: React.FC = () => {
  return (
    <div className="mt-8">
      <h2 className="text-xl font-bold mb-4">AI Content Settings</h2>
      <Card className="bg-blue-50">
        <CardContent className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-medium mb-2">Automated Content Schedule</h3>
              <Select defaultValue="biweekly">
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select frequency" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="weekly">Weekly</SelectItem>
                  <SelectItem value="biweekly">Bi-Weekly</SelectItem>
                  <SelectItem value="monthly">Monthly</SelectItem>
                  <SelectItem value="custom">Custom</SelectItem>
                </SelectContent>
              </Select>
              <p className="text-sm text-gray-600 mt-2">
                Content will be automatically generated and scheduled based on this frequency.
              </p>
            </div>
            
            <div>
              <h3 className="font-medium mb-2">Content Topics Focus</h3>
              <Select defaultValue="saas">
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select focus" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="saas">SaaS Reseller Business</SelectItem>
                  <SelectItem value="marketing">Referral Marketing</SelectItem>
                  <SelectItem value="customer">Customer Success</SelectItem>
                  <SelectItem value="trends">Industry Trends</SelectItem>
                </SelectContent>
              </Select>
              <p className="text-sm text-gray-600 mt-2">
                AI will generate content focusing on these topics.
              </p>
            </div>
            
            <div>
              <h3 className="font-medium mb-2">Social Media Sharing</h3>
              <Select defaultValue="all">
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select platforms" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Platforms</SelectItem>
                  <SelectItem value="twitter">Twitter Only</SelectItem>
                  <SelectItem value="linkedin">LinkedIn Only</SelectItem>
                  <SelectItem value="facebook">Facebook Only</SelectItem>
                  <SelectItem value="custom">Custom Selection</SelectItem>
                </SelectContent>
              </Select>
              <p className="text-sm text-gray-600 mt-2">
                Published posts will be automatically shared on these platforms.
              </p>
            </div>
            
            <div>
              <h3 className="font-medium mb-2">Content Style</h3>
              <Select defaultValue="professional">
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select style" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="professional">Professional</SelectItem>
                  <SelectItem value="conversational">Conversational</SelectItem>
                  <SelectItem value="educational">Educational</SelectItem>
                  <SelectItem value="persuasive">Persuasive</SelectItem>
                </SelectContent>
              </Select>
              <p className="text-sm text-gray-600 mt-2">
                AI will write content in this style.
              </p>
            </div>
          </div>
          
          <div className="mt-6 text-right">
            <Button>Save AI Settings</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AIContentSettings;
